<template>
    <layout class="viewport">
        <sider ref="sider" hide-trigger collapsible :collapsed-width="0" v-model="isCollapsed">
            <Menu theme="dark" class="menu" @on-select="onSelect">
                <template v-for="(item, i) in menu">
                    <menu-item v-if="!current || i==current" :key="i" :name="i" class="item">
                        <icon :type="item.icon" class="icon"/>
                        <span class="text">{{item.text}}</span>
                        <icon v-if="i == current" type="md-arrow-dropleft" class="extend-icon"/>
                        <Icon v-else type="md-arrow-dropdown" class="extend-icon"/>
                    </menu-item>
                </template>
            </Menu>
            <div v-if="bar" :is="bar" v-model="books" @open-modal="openModal"></div>
        </sider>
        <layout class="main">
            <header class="topbar">
                <div @click="collapsedSider" class="left"></div>
                <span class="title">霄鸟云玩具配件配套 行业专业DM杂志</span>
                <div class="right"></div>
            </header>
            <content class="content">
                <bookshelves v-model="books" ref="bookshelves" @read="onRead"/>
            </content>
            <footer class="bottombar">
                <row class="bar">
                    <i-col span="8" class="col">
                        <div class="left"></div>
                    </i-col>
                    <i-col span="8" class="col" style="text-align:center;">
                        <div class="middle">
                            <span>共</span>
                            <span>{{bookcount}}</span>
                            <span>本</span>
                        </div>
                    </i-col>
                    <i-col span="8" class="col">
                        <div class="right"></div>
                    </i-col>
                </row>
            </footer>
        </layout>
        <Modal v-model="isOpened">
            <div slot="header">
                书刊详情
            </div>
            <div v-if="book" class="bookdetail">
                <h5 class="name">{{book.name}}</h5>
                <div class="book">
                    <book :width="showWidth" :height="showHeight" :cover="book.cover"/>
                </div>
                <div class="shelf">
                    <img src="@/assets/shelf-bottom.png"/>
                </div>
            </div>
            <div slot="footer">
                <Button type="primary" size="large" long @click="toBook">立即查看</Button>
            </div>
        </Modal>
    </layout>
</template>

<script>
import book from '../components/book.vue';
import booklist from '../components/booklist.vue';
import booksearch from '../components/booksearch.vue';
import bookshelves from '../components/bookshelves.vue';

export default {
    name: 'home',
    components: {
        book,
        booklist,
        booksearch,
        bookshelves,
    },
    data() {
        return {
            books: [],
            menu: {
                search: {
                    icon: 'ios-search',
                    text: '书架搜索',
                    bar: 'booksearch',
                },
                list: {
                    icon: 'ios-list-box-outline',
                    text: '书刊列表',
                    bar: 'booklist',
                }
            },
            bar: null,
            current: null,
            isCollapsed: true,
            book: null,
            booktag: null,
            isOpened: false,

            showWidth: 80,
            showHeight: 108,
        }
    },
    computed: {
        bookcount() {
            return Object.keys(this.books).length;
        }
    },
    methods: {
        load() {
            let url = '/Book/Bookshelves/index';
            this.ajaxPost(url, {}).then(response => {
                if (0 == response.data.code) {
                    this.books = response.data.books;
                }
            }).catch(error => {
                console.log(error);
            });
        },
        collapsedSider () {
            this.$refs.sider.toggleCollapse();
        },
        onSelect(name) {
            if (name == this.current) {
                this.current = null;
                this.bar = null;
            } else {
                this.current = name;
                this.bar = this.menu[name].bar;
            }
        },
        onRead(name) {
            this.book = this.books[name];
            this.booktag = name;
            this.isOpened = true;
        },
        openModal(book, i) {
            this.book = book;
            this.booktag = i;
            this.isOpened = true;
        },
        toBook() {
            this.$router.push({
                path: '/periodical.html',
                query: {
                    name: this.booktag,
                }
            });
        }
    },
    mounted() {
        this.load();
        this.wxCall([
            'checkJsApi','onMenuShareTimeline','onMenuShareAppMessage'
        ]).then(response => {
            let link = response.data.domain + '/Book/F/index.html';
            let imgUrl = response.data.domain + '/Book/Public/images/mlogo.jpg';
            window.wx.onMenuShareTimeline({
                title: '《霄鸟云玩具配件配套》 行业专业DM杂志',
                link: link,
                imgUrl: imgUrl,
            });
            window.wx.onMenuShareAppMessage({
                title: '《霄鸟云玩具配件配套》 行业专业DM杂志', // 分享标题
                desc: "《霄鸟云玩具配件配套》 行业专业DM杂志", // 分享描述
                link: link,
                imgUrl: imgUrl,
                type: 'link',
                dataUrl: '',
            });
        });

        // 设置显示书刊的宽度。
        console.log(this.$el.clientWidth);
        this.showWidth = this.$el.clientWidth * 0.5;
        this.showHeight = this.showWidth * 1.357;
    }
}
</script>

<style lang="less" scoped>
.viewport {
    width: 100vw;
    height: 100vh;
}
.menu {
    padding: 20px;
    width: 100% !important;

    .item {
        overflow: hidden;
        position: relative;
        padding: 8px;
        font-size: 16px;
        line-height: 20px;
        white-space: nowrap;
        color: white;
    }

    .text {
        white-space: nowrap;
    }

    .icon {
        font-size: 24px;
    }

    .extend-icon {
        position: absolute;
        right: 0;
        font-size: 24px;
    }
}
.main {
    position: relative;
}
.topbar {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100vw;
    height: 60px;
    padding: 20px;
    background-image: url(../assets/board.png);
    background-size: auto 100%;
    background-repeat: repeat;

    .left {
        float: left;
        width: 39px;
        height: 29px;
        background-origin: padding-box;
        background-attachment: scroll;
        background-clip: border-box;
        background-image: url(../assets/button.png);
        background-position-x: -34px;
        background-position-y: -112px;
        background-repeat: no-repeat;
        background-size: auto auto;

        &:hover {
            background-position-y: -147px;
        }
        &:active {
            background-position-y: -182px;
        }
    }

    .title {
        margin: 0.5em;
        font-size: 16px;
        font-weight: 700;
        text-align: center;
        color: rgb(111, 77, 23);
        text-shadow: rgb(245, 188, 159) 1px 1px 0px;
    }

    .right {
        float: right;
    }
}
.content {
    position: absolute;
    overflow: auto;
    top: 60px;
    left: 0;
    bottom: 42px;
    width: 100vw;
}

.bottombar {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100vw;
    height: 42px;
    line-height: 42px;
    background-image: url(../assets/board.png);
    background-size: auto 100%;
    background-repeat: repeat;

    .bar {
        width: 100%;
        height: 100%;
    }
    .col {
        height: 100%;
    }
    .middle {
        display: inline-block;
        padding: 5px 25px;
        text-align: center;
        color: rgb(243, 187, 155);
        line-height: 20px;
        background-color: rgb(77, 47, 47);
        border-radius: 15px;
        box-shadow: 2px 2px 2px #191919 inset;
        letter-spacing: 0.25em;
    }
}

.bookdetail {
    text-align: center;

    .name {
        font-size: 16px;
    }

    .shelf {
        width: 80%;
        margin-left: auto;
        margin-right: auto;
        margin-top: -18px;

        img {
            width: 100%;
        }
    }
}
</style>

